export { default, type ReviewsSectionProps } from './ReviewsSection';
